<template lang="pug">
.content
    VidUtil(
        :src="vids[current]"
        :loop="loop[current]"
        width="3840"
        height="2160"
        duration="1"
        :endCallBack="vidEnded"
        :vidProgress="vidProgress"
    )
    .attachVids
        .attach.attach1(
            :style="`opacity:${this.attachOpacity}`"
            :class="this.state===0?'pos0':'pos1'"
        )
            VidUtil(
                :src="attach1Src"
                loop="true"
                width="618"
                height="348"
                duration="1"
            )
        .attach.attach2(
            :style="`opacity:${this.attachOpacity}`"
            :class="this.state===0?'pos0':'pos1'"
        )
            VidUtil(
                :src="attach2Src"
                loop="true"
                width="618"
                height="348"
                duration="1"
            )
    .virtualBtns(v-if="debug")
        .btn(:class="state!==0?'disabled':''" @click="physicalClick1") FlexE
        .btn(:class="state!==1?'disabled':''" @click="physicalClick2") SRv6
        .btn(:class="state!==2?'disabled':''" @click="physicalClick3") iFIT
        //- .btn block 1
        //- .btn block 2
    .btnsWrapper
        .btnsInner
            .left1
            .left2
            .btns
                .btn(@click="onClick1" :class="state===0?'enabled':''")
                    .inner 5G Ambulance
                .btn(@click="onClick2" :class="state===1?'enabled':''")
                    .inner Remote Diagnosis
                .btn(@click="onClick3" :class="state===2?'enabled':''")
                    .inner VR Gaming
        .bg

    .debug(v-if="debug")
        h1 {{current}}
        //- h2 {{attach1Src}}
        //- h2 {{attach2Src}}

</template>

<script>
import SocketService from '@/services/SocketService'
import VidUtil from '@/utils/VidUtil'
import KeyService from '@/services/KeyService'
const basePath = './static/A/A_2/'
export default {
    components:{
        VidUtil
    },
    data(){
        return {
            //用到的视频
            vids:[
                //`${basePath}1.mp4`,
                //state 0
                `${basePath}1.5.mp4`,//0
                `${basePath}2.mp4`,//1
                `${basePath}2.5.mp4`,//2
                `${basePath}3.mp4`,//3


                //state1
                `${basePath}tmp/2-1.mp4`,//4
                `${basePath}tmp/2-2.mp4`,//5



                //state2
                `${basePath}tmp/3-1.mp4`,//6
                `${basePath}tmp/3-2.mp4`,//7
                `${basePath}tmp/3-3.mp4`,//8
                `${basePath}tmp/3-4.mp4`,//9
                `${basePath}tmp/3-5.mp4`,//10
            ],
            attchVids:[
                `${basePath}1-1.mp4`,//6
                `${basePath}1-2.mp4`,//6
                `${basePath}2-1.mp4`,//6
                `${basePath}2-2.mp4`,//7
                `${basePath}2-3.mp4`,//8
                `${basePath}2-4.mp4`,//9

            ],
            //是否循环
            loop:[
                //true,
                //state 0
                false,
                true,
                false,
                true,


                //state1
                true,
                true,



                //state2
                true,
                true,
                true,
                true,
                true,
            ],
            waitForAttach1: true,
            attach1Src: '',
            waitForAttach2: true,
            attach2Src: '',
            attachOpacity: 0,
            state: 0,
            current: 0,
            debug: true
        }
    },
    mounted(){
        KeyService.getInstance().n.add(this.next.bind(this))
    },
    methods:{
        next(){
            this.current = (this.current +1)%this.vids.length
        },
        vidEnded(){
            this.current = (this.current+1)%this.vids.length

        },
        vidProgress(p){
            // console.log("vidProgress:"+p)
            if(this.current === 0){
                if(p>0.2 && this.waitForAttach1){
                    this.waitForAttach1 = false
                    this.attachOpacity = 1
                    this.attach1Src = this.attchVids[0]
                    this.attach2Src = this.attchVids[1]
                }

            }
        },
        onClick1(){
            this.waitForAttach1 = true
            this.attachOpacity = 0
            this.state = 0
            this.current = 0
            SocketService.getInstance().emit('a',{type:'state0', event:'reset'})
        },
        onClick2(){
            if(this.waitForAttach1){
                this.waitForAttach1 = false
            }
            this.attachOpacity = 0
            setTimeout(()=>{
                this.attachOpacity = 1
            }, 700)
            this.state = 1
            this.current = 4
            this.attach1Src = this.attchVids[3]
            this.attach2Src = this.attchVids[3]
            SocketService.getInstance().emit('a',{type:'state1', event:'reset'})
        },
        onClick3(){
            this.waitForAttach1 = false
            this.attachOpacity = 0
            this.state = 2
            this.current = 6
            SocketService.getInstance().emit('a',{type:'state2', event:'reset'})
        },
        physicalClick1(){
            if(this.state === 0){
                this.current = 2
                console.log('physical clicked 1')
                SocketService.getInstance().emit('a',{type:'state0', event:'update'})
            }
        },
        physicalClick2(){
            if(this.state === 1){
                this.current = 5
                console.log('physical clicked 2')
                SocketService.getInstance().emit('a',{type:'state1', event:'update'})
            }
        },
        physicalClick3(){
            if(this.state === 2){
                this.current = 7
                console.log('physical clicked 3')
                SocketService.getInstance().emit('a',{type:'state2', event:'update'})
            }
        }
    }

}
</script>

<style lang="sass" scoped>

@import '@/styles/common'
.content
    +full()
    overflow: hidden
    .debug
        position: absolute
        font-size: pxToRem(100)
        color: white
        top: pxToRem(20)
        left: pxToRem(20)
    .btnsWrapper
        position: absolute
        height: pxToRem(70)
        bottom: pxToRem(44)
        right: 0
        margin-right: pxToRem(-80)
        .bg
            position: absolute
            pointer-events: none
            width: pxToRem(43)
            height: pxToRem(157)
            top: pxToRem(-44)
            right: pxToRem(80)
            background-image: url("~@/assets/A/A_2/right.png")
            // background-color: red
            background-repeat: repeat-y
            background-position: 92% center
        .btnsInner
            transform: skew(-30deg, 0deg)
            overflow: hidden
            .left1
                position: relative
                display: inline-block
                width: pxToRem(12)
                height: pxToRem(70)
                border-right: 1px #547a88 solid
                border-top: 1px #547a88 solid
                border-bottom: 1px #547a88 solid
                border-left: pxToRem(6) #58c8e2 solid
                margin-right: 3px
            .left2
                position: relative
                display: inline-block
                width: pxToRem(10)
                height: pxToRem(70)
                border-right: 1px #547a88 solid
                border-top: 1px #547a88 solid
                border-bottom: 1px #547a88 solid
                border-left: 1px #547a88 solid
                margin-right: 3px
            .btns
                border-top: 1px solid #55737d
                border-bottom: 1px solid #55737d
                border-left: 2px solid #58c8e2
                position: relative
                display: inline-block
                height: pxToRem(70)
                overflow: hidden
                .btn
                    color: white
                    &.enabled
                        color: #edac74
                        &:before
                            box-shadow: inset 0 0 1.5rem #58c8e2
                    cursor: pointer
                    font-size: pxToRem(34)
                    position: relative
                    margin-top: pxToRem(-35)
                    height: pxToRem(140)
                    padding-left: pxToRem(33)
                    padding-right: pxToRem(33)
                    margin-left: pxToRem(2)
                    margin-right: pxToRem(2)
                    line-height: pxToRem(140)
                    text-align: center
                    display: inline-block
                    border-left: 1px solid #1f4b68
                    background-image: url("~@/assets/A/A_2/glow.png")
                    // background-color: green
                    background-repeat: repeat-y
                    background-position: right center
                    overflow: hidden
                    &:nth-child(1)
                        margin-left: 0
                        border-left: none
                    &:nth-child(3)
                        .inner
                            padding-right: pxToRem(100)
                    &:before
                        content: ''
                        mouse-events: none
                        position: absolute
                        left: -50%
                        bottom: pxToRem(40)
                        width: 200%
                        height: 100%
                    &:hover
                        &:before
                            box-shadow: inset 0 0 1.5rem #58c8e2
                    .inner
                        mouse-events: none
                        transform: skew(30deg, 0deg)
                        text-shadow:  0 0.2rem 0.3rem black
    .attachVids
        +full()
        left: 0
        top: 0
        .attach
            position: absolute
            width: pxToRem(618)
            height: pxToRem(348)
            // opacity: 0.3
            // background: red
            transition: opacify 0.5s
            &.attach1
                &.pos0
                    left: pxToRem(526)
                    top: pxToRem(1629)
                &.pos1
                    left: pxToRem(1172)
                    top: pxToRem(1590)
            &.attach2
                &.pos0
                    left: pxToRem(2220)
                    top: pxToRem(1629)
                &.pos1
                    left: pxToRem(2480)
                    top: pxToRem(1590)

    .virtualBtns
        +full()
        .btn
            &.disabled
                opacity: 0.2
            color: white
            font-size: pxToRem(30)
            width: pxToRem(200)
            margin: pxToRem(30)
            text-align: center
            padding: pxToRem(20) pxToRem(20)
            background-color: rgba(77,77,77,0.3)
            &:nth-child(1)
                margin-top: pxToRem(300)
        
</style>